import { jsx as _jsx } from "react/jsx-runtime";
{
    /* <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
     */
}
const XMark = (props) => {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", strokeWidth: 1, stroke: "currentColor" }, props, { children: _jsx("path", { d: "M9.56388 8.64652L9.21047 9.00007L9.56395 9.35355L17.2923 17.0819L17.0831 17.2903L9.35355 9.56071L8.99993 9.20709L8.64638 9.56078L0.917436 17.2928L0.707178 17.0826L8.43922 9.35362L8.79291 9.00007L8.43929 8.64645L0.707733 0.914891L0.916882 0.706482L8.64645 8.43605L9 8.7896L9.35355 8.43605L17.0831 0.706481L17.2923 0.914962L9.56388 8.64652Z", fill: "currentColor", stroke: "currentColor" }) })));
};
export default XMark;
